import { Reminder } from './models';

export interface ReminderRequest {
    ID: number;
    FollowUpDate: string; 
    IsResolved: boolean;
    CreatedDate: string; 
    CreatedByUserID: number;
    LastModifiedByUserID?: number;
    LastModifiedDate?: string; 
    Priority?: number;
    CompanyID?: number;
    ParentReminderID?: number;
    DocumentID?: number;
    NoteID?: number; 

    ReminderNote?: {
        ID: number; 
        TableName: string; 
        RecordID: number | null; 
        NoteTypeID: number; 
        NoteText: string; 
    }
    
    CreatedByUserName?: string;
    LastModifiedByUserName?: string;
    CompanyName?: string;
}

export function toReminderRequest(reminder: Reminder): ReminderRequest {
    if (!reminder) {
        return null;
    }
    
    const safeToISOString = (date: any): string => {
        try {
            if (date instanceof Date) {
                return date.toISOString();
            }
            else if (typeof date === 'string' && !isNaN(Date.parse(date))) {
                return new Date(date).toISOString();
            }
            return new Date().toISOString();
        } catch (error) {
            return new Date().toISOString();
        }
    };

    const request: ReminderRequest = {
        ID: reminder.id || 0,

        FollowUpDate: reminder.followUpDate ? safeToISOString(reminder.followUpDate) : new Date().toISOString(),
        IsResolved: reminder.isResolved !== undefined ? reminder.isResolved : false,
        CreatedDate: reminder.createdDate ? safeToISOString(reminder.createdDate) : new Date().toISOString(),
        CreatedByUserID: reminder.createdByUserID || 0,
        LastModifiedByUserID: reminder.lastModifiedByUserID || 0, 
        
        ...(reminder.lastModifiedDate ? { LastModifiedDate: safeToISOString(reminder.lastModifiedDate) } : {}),
        Priority: reminder.priority || 3,
        CompanyID: reminder.companyID,
        ParentReminderID: reminder.parentReminderID,
        CreatedByUserName: reminder.createdByUserName || '',
        LastModifiedByUserName: reminder.lastModifiedByUserName,
        CompanyName: reminder.companyName,
        NoteID: reminder.noteID, 
        ReminderNote:{
            ID: reminder.noteID || 0, 
            TableName: reminder.noteTableName || '', 
            RecordID: reminder.recordID || null,
            NoteTypeID: reminder.noteTypeID || 0,
            NoteText: reminder.note || ''
        } 
    };
    
    if (reminder.documentID !== undefined) {
        request.DocumentID = reminder.documentID;
    }
    
    return request;
}



// WEBPACK FOOTER //
// ./src/app/core/components/reminders/models/requests.ts